// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4eac27f7","209":"0256048d","213":"c1b2f85b","223":"c7361e0a","239":"5c15d221","453":"70152524","548":"5cac0a7d","708":"830acd90","732":"08f20727","778":"cf5c843f"}[chunkId] + ".chunk.js";
};